// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"28":"4f0eb2b3","86":"cf0a175f","115":"a71ec1cb","705":"cf0a175f"}[chunkId] + ".chunk.css";
};